module.exports = __webpack_public_path__ + "static/media/DIN-RegularAlternate.3a2feb7f.woff";